<template>  
    <div class="mm-select">
        <div class="mm-selected">{{txt}}</div>
        <div class="mm-arrow"></div>
        <div class="mm-selections">            
            <div v-for="item in items" @click='click(item)' class="mm-item">{{item.txt}}</div>
        </div>
    </div>


</template>

<script>
    export default {
        props: ['value', 'items'],
        data() {
            return{
                txt: null,
                _value: null
            };
        },
        created: () => {
           
        },
        methods:{
            click(item){
                this._value=item.val;
                this.$emit("input",this._value);
            }
        },
        watch: {           
            value: {
                handler(va, old) {
                    this._value=va;
                    for(var i in this.items){
                        if(this.items[i].val == va){
                            this.txt =  this.items[i].txt;
                        }
                    }
                },
                immediate: true
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/public_app/elements/custom/MmSelect.vue